import {
    ShoppingPathJointReportReasonValueObject
} from "../../../../model/vo/content/ShoppingPathJointReportReasonValueObject";
import {ShoppingPathJointReportReasonIO} from "../../../../io/content/ShoppingPathJointReportReasonIO";
import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../../common/DetailPage";
import {RouteContext} from "../../../RouteContext";
import {ShoppingFunnelValueObject} from "../../../../model/vo/content/ShoppingFunnelValueObject";
import {ShoppingFunnelIO} from "../../../../io/content/ShoppingFunnelIO";
import {ShoppingPathJointValueObject} from "../../../../model/vo/content/ShoppingPathJointValueObject";
import {ListPage} from "../../common/ListPage";
import {ShoppingValueObject} from "../../../../model/vo/content/ShoppingValueObject";
import {ShoppingIO} from "../../../../io/content/ShoppingIO";
import React from "react";

const propertyDetail: DetailPagePropertyIndicator<ShoppingFunnelValueObject> = {

}

type Panel = DetailPagePanelConstraint

const panelDescription: Record<Panel, string> = {
    Main: '기본',
    shoppingId: '쇼핑ID',

}

const panelDetail: DetailPagePanelIndicator<ShoppingFunnelValueObject, Panel> = {

    shoppingId: (props: RouteContext, item: ShoppingFunnelValueObject): JSX.Element => <>
    <ListPage
        {...props}
        key={'shopping-detail-list-page-shopping-modification'}
        description={ShoppingValueObject.description}
        excluded={new Set<keyof ShoppingValueObject>()}
        list={ShoppingIO.list}
        count={ShoppingIO.count}
        delete={ShoppingIO.delete}
        detailHref={item => `/admin/shoppings/${item.id}`}
        editHref={item => `/admin/shoppings/edit/${item.id}`}
        initialSearchConditions={[
            {
                name: 'id',
                value: String(item.shoppingId),
                condition: 'Equal'
            },
        ]}/>
</>,
}

export default function Detail(props: RouteContext) {
    return <>
        <DetailPage
            {...props}
            propertyDescription={ShoppingFunnelValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={ShoppingFunnelIO.get} />
    </>
}